import React, { useEffect, useState } from "react";
import FilterComponent, { FilterType } from "./Filter";
import HotspotInfo from "./HospotInfo";
import Maps from "./Maps";
import HotSpotInfoTable from "../../common/HotSpotInfoTable";
import PagePaginate from "../../common/PagePaginate";
import HotspotInfoDonutChart from "../../common/HotSpotInfoDonutChart";
import HotSpotInfoBarchart from "../../common/HotSpotInfoBarChart";
import Districts from "../../../Districts.json";
import Provinces from "../../../Provinces.json";
import SubDistrict from "../../../Subdistrict.json";
import moment from "moment-timezone";
import Regions from "../../../Regions.json";
import {
  DashboardAPI,
  DashBoardParamsType,
} from "../../../api/dashboard/Dashboard";
import _, { orderBy } from "lodash";
import NotFoundData from "./Notfound";
import { useLoading } from "../../../context/LoadingContext";
export interface ParamsType {
  startDate?: Date;
  endDate?: Date | null;
  satellite?: string;
  country?: string;
  fileName?: string;
  provinceGroup?: string;
  region?: string;
  province?: string[];
  district?: string;
  subdistrict?: string;
}
export interface DashBoardResponseType {
  items: Item[];
  matched: number;
  returned: number;
}
export interface Item {
  ap_idn: number;
  ap_tn: string;
  count_id: number;
  max_timestamp: number;
  max_updated_at: string;
  updated_at: string;
  pv_idn: number;
  file_name: string;
  pv_tn: string;
  tb_idn: number;
  tb_tn: string;
  ct_tn: string;
  lu_code: number;
  re_royin: string;
  satellite: string;
  ct_en: string;
  status: string;
  instrument: string;
}
export interface BarChartAseanData {
  id: number;
  name: string;
  value: number;
  color: string;
}
export interface DonutChartDataType {
  id: string;
  name: string;
  value: number;
  color: string;
  totalValue: number;
}
export interface BarChartDataType {
  name: string;
  lu_code_1: number;
  lu_code_2: number;
  lu_code_3: number;
  lu_code_4: number;
  lu_code_5: number;
  lu_code_6: number;
  total: number;
}
export interface LuBarChartType {
  count_id: number;
  lu_code: number;
  max_timestamp: number;
  re_royin: string;
}
export interface ThaiDataTableType {
  name: string;
  lu_code_4?: LuCodeTableType;
  lu_code_2: LuCodeTableType;
  lu_code_6: LuCodeTableType;
  lu_code_3: LuCodeTableType;
  lu_code_5: LuCodeTableType;
  lu_code_1?: LuCodeTableType;
}
export interface AseanDataTableType {
  name: string;
  VIIRS: number;
  MODIS: number;
  total: number;
  max_timestamp: number;
}
export interface LuCodeTableType {
  pending: number;
  inprogress: number;
  complete: number;
  total: number;
}

function DashBoard() {
  const [filterData, setFilterData] = useState<FilterType | undefined>();
  const [donutChartData, setDonutChartData] = useState<DonutChartDataType[]>(
    []
  );
  const [barChartData, setBarChartData] = useState<BarChartDataType[]>();
  const [hotspotStatusList, setHotspotStatusList] = useState<Item[]>();
  const [barChartAsean, setBarChartAsean] = useState<BarChartAseanData[]>();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [dataDate, setDataDate] = useState<any>();
  const [itemStart, setItemStart] = useState(0);
  const [barChartTitle, setBarChartTitle] = useState("ระดับภูมิภาค");
  const [barChartCountItem, setBarChartCountItem] = useState(0);
  const [sorted, setSorted] = useState<"DESC" | "ASC">("DESC");

  const [sortedTable, setSortedTable] = useState("DESC");
  const [dataTable, setDataTable] = useState<any>([]);
  const [dataTableTitle, setDataTableTitle] = useState("ระดับภูมิภาค");
  const [oldDataTable, setOldDataTable] = useState<
    ThaiDataTableType[] | AseanDataTableType[]
  >([]);
  const [tableColumnName, setTableColumnName] = useState("");
  const [donutType, setDonutType] = useState<"Thailand" | "Asean">("Thailand");
  const [browserInfo, setBrowserInfo] = useState({
    name: "",
  });
  const { onSetLoading } = useLoading();
  const luCodeMappings: any = {
    1: {
      name: "พื้นที่ป่าอนุรักษ์",
      color: "#91E478",
    },
    2: {
      name: "พื้นที่เขต สปก.",
      color: "#E865EE",
    },
    3: {
      name: "ป่าสงวนแห่งชาติ",
      color: "#3B923E",
    },
    4: {
      name: "พื้นที่ริมทางหลวง(50เมตร)",
      color: "#AF692E",
    },
    5: {
      name: "พื้นที่เกษตร",
      color: "#F8EA6E",
    },
    6: {
      name: "พื้นที่ชุมชนและอื่นๆ",
      color: "#C3C3BE",
    },
  };
  const colorArray = [
    "#D55B26",
    "#E86D1B",
    "#E58331",
    "#EC9235",
    "#F19D38",
    "#F2AB47",
    "#F4BA61",
    "#F7CE8B",
    "#FAE1B7",
    "#FDF3E2",
  ];
  const handlePrintPage = async () => {
    if (browserInfo.name !== "Safari") {
      let element = document.getElementById("dashboard");
      if (element) {
        element.classList.remove("rotate-class");
        element.classList.remove("dashboard-safari");
      }
      window.print();
    } else {
      let element = document.getElementById("dashboard");
      if (element) {
        element.classList.add("rotate-class");
        element.classList.add("dashboard-safari");
      }
      window.print();
    }
  };
  const handleFilter = (data: FilterType | undefined) => {
    setFilterData(data);
  };
  const getDashboardDonutData = async (params: FilterType | undefined) => {
    try {
      onSetLoading(true);
      let payload: DashBoardParamsType = {};
      let provinceList: any = [];
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();

        payload = {
          ct_en: "Thailand",
          instrument: "VIIRS",
          satellite: "Suomi NPP",
          groupby: "lu_code",
          aggregate: "count:id",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        if (params.countryType?.id === 1) {
          payload = {
            ct_en: "Thailand",
            groupby: "lu_code",
            aggregate: "count:id",
            limit: 10000,
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
            re_royin:
              params.region?.RegionName !== "ทั้งหมด"
                ? params.region?.RegionCode
                : undefined,
            ap_idn:
              params.district?.DistrictCode !== "0"
                ? params.district?.DistrictCode
                : undefined,
            tb_idn:
              params.subdistrict?.SubdistrictCode !== "0"
                ? params.subdistrict?.SubdistrictCode
                : undefined,
          };
          if (params.provinceGroup?.id === 2) {
            let northProvince = Provinces.filter(
              (e) => e.Group17Provinces === 1
            );
            provinceList = northProvince;
          } else {
            if (params.province) {
              if (params.province[0].ProvinceCode !== "0") {
                provinceList = params.province;
              }
            }
          }
        } else if (params.countryType?.id === 2) {
          payload = {
            asian: 1,
            groupby: "ct_en,ct_tn",
            aggregate: "count:id",
            limit: 10000,
            file_name: params.fileName,
          };
        }
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();

          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.satellite = params.satellite;
        }
      }

      const data = (await DashboardAPI(
        payload,
        provinceList.length > 0 ? provinceList : undefined
      )) as DashBoardResponseType;
      if (data) {
        if (!params || params.countryType?.id === 1) {
          const luCodeTotal = _.groupBy(data.items, "lu_code");
          const luCodeTotals = _.mapValues(luCodeTotal, (items) =>
            _.sumBy(items, "count_id")
          );
          const totalValue = _.sumBy(data.items, "count_id");
          const newArray: any = _.map(luCodeTotals, (value, lu_code) => ({
            id: `lu_code_${lu_code}`,
            name: luCodeMappings[lu_code].name,
            value: value,
            color: luCodeMappings[lu_code].color,
            totalValue: totalValue,
          }));
          setDonutType("Thailand");
          setDonutChartData(newArray);
        } else {
          const totalValue = _.sumBy(data.items, "count_id");
          const sortedItems = _.orderBy(data.items, ["count_id"], ["desc"]);
          const newArray: any = sortedItems.map((item, index) => ({
            id: index,
            name: item.ct_tn,
            value: item.count_id,
            color: colorArray[index],
            totalValue: totalValue,
          }));

          setDonutType("Asean");
          setDonutChartData(newArray);
        }
      } else {
        setDonutChartData([]);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };
  const getDashboardBarData = async (params: FilterType | undefined) => {
    try {
      onSetLoading(true);
      let payload: DashBoardParamsType = {};
      let provinceList: any = [];
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();

        payload = {
          ct_en: "Thailand",
          instrument: "VIIRS",
          satellite: "Suomi NPP",
          groupby: "lu_code,re_royin",
          aggregate: "count:id",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        if (params.countryType?.id === 1) {
          payload = {
            ct_en: "Thailand",
            groupby: "lu_code,re_royin",
            aggregate: "count:id",
            limit: 10000,
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
          };

          if (params?.provinceGroup?.id === 2) {
            payload.groupby = "lu_code,pv_tn,pv_idn";
            let northProvince = Provinces.filter(
              (e) => e.Group17Provinces === 1
            );
            provinceList = northProvince;
          }

          if (params.region?.RegionCode !== "0") {
            payload.re_royin = params.region?.RegionCode;
            payload.groupby = "lu_code,pv_tn,pv_idn";
          }

          if (params.province && params.province.length > 0) {
            const hasProvinceCodeZero = params.province.some(
              (item) => item.ProvinceCode === "0"
            );
            if (!hasProvinceCodeZero) {
              payload.groupby = "lu_code,ap_idn,ap_tn";
              provinceList = params.province;
            }
          }

          if (params.district?.DistrictCode !== "0") {
            payload.ap_idn = params.district?.DistrictCode;
            payload.groupby = "lu_code,tb_idn,tb_tn";
          }

          if (params.subdistrict?.SubdistrictCode !== "0") {
            payload.tb_idn = params.subdistrict?.SubdistrictCode;
            payload.groupby = "lu_code";
          }
        } else {
          payload = {
            asian: 1,
            groupby: "ct_en,ct_tn",
            aggregate: "count:id",
            limit: 10000,
          };
        }
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.satellite = params.satellite;
        }
      }

      const data = (await DashboardAPI(
        payload,
        provinceList.length > 0 ? provinceList : undefined
      )) as DashBoardResponseType;
      if (data.items.length > 0) {
        if (!params || params.countryType?.id === 1) {
          let barData: any = [];
          if (
            params?.subdistrict &&
            params?.subdistrict?.SubdistrictCode !== "0"
          ) {
            const luCodeTotals = _.chain(data.items)
              .groupBy("lu_code")
              .mapValues((group) => _.sumBy(group, "count_id"))
              .value();
            const luCodeToName = {
              1: "พื้นที่ป่าอนุรักษ์",
              2: "พื้นที่เขต สปก.",
              3: "ป่าสงวนแห่งชาติ",
              4: "พื้นที่ริมทางหลวง(50เมตร)",
              5: "พื้นที่เกษตร",
              6: "พื้นที่ชุมชนและอื่นๆ",
            };
            const resultArray = _.map(luCodeToName, (name, lu_code) => ({
              name,
              [`lu_code_${lu_code}`]: luCodeTotals[lu_code] || 0,
              total: _.sum(Object.values(luCodeTotals)),
            }));
            barData = _.orderBy(resultArray, "total", "desc");
          } else if (
            params?.district &&
            params?.district?.DistrictCode !== "0"
          ) {
            const transformedData = _.chain(data.items)
              .groupBy("tb_idn")
              .map((items, tb_idn) => {
                const luCodeTotals: any = {
                  lu_code_1: 0,
                  lu_code_2: 0,
                  lu_code_3: 0,
                  lu_code_4: 0,
                  lu_code_5: 0,
                  lu_code_6: 0,
                };
                _.forEach(data.items, (item) => {
                  if (item.tb_idn === Number(tb_idn.toString())) {
                    luCodeTotals[`lu_code_${item.lu_code}`] += item.count_id;
                  }
                });

                const total = _.sumBy(items, "count_id");

                return {
                  name: items[0].tb_tn,
                  ...luCodeTotals,
                  total,
                };
              })
              .value();

            barData = _.orderBy(transformedData, "total", "desc");
          } else if (
            params?.province &&
            params?.province[0].ProvinceCode !== "0"
          ) {
            const transformedData = _.chain(data.items)
              .groupBy("ap_idn")
              .map((items, ap_idn) => {
                const luCodeTotals: any = {
                  lu_code_1: 0,
                  lu_code_2: 0,
                  lu_code_3: 0,
                  lu_code_4: 0,
                  lu_code_5: 0,
                  lu_code_6: 0,
                };
                _.forEach(data.items, (item) => {
                  if (item.ap_idn === Number(ap_idn.toString())) {
                    luCodeTotals[`lu_code_${item.lu_code}`] += item.count_id;
                  }
                });
                const total = _.sumBy(items, "count_id");
                return {
                  name: items[0].ap_tn,
                  ...luCodeTotals,
                  total,
                };
              })
              .value();
            barData = _.orderBy(transformedData, "total", "desc");
          } else if (params?.provinceGroup?.id === 2) {
            let arrayOfResult: any = [];
            let groupData: any = {};
            let groupProvinces = Provinces.filter(
              (p) => p.Group17Provinces === 1
            );

            _.forEach(groupProvinces, (province) => {
              let dataInProvince = data.items.filter(
                (item) => item.pv_idn === Number(province.ProvinceCode)
              );
              groupData[`${province.ProvinceCode}`] = dataInProvince;
            });

            _.forEach(groupProvinces, (province) => {
              let dataInProvince = groupData[province.ProvinceCode];
              if (dataInProvince.length > 0) {
                let arrayOfLucode: any = {};
                let lu_code_1 = dataInProvince.filter(
                  (d: any) => d.lu_code === 1
                );
                let lu_code_2 = dataInProvince.filter(
                  (d: any) => d.lu_code === 2
                );
                let lu_code_3 = dataInProvince.filter(
                  (d: any) => d.lu_code === 3
                );
                let lu_code_4 = dataInProvince.filter(
                  (d: any) => d.lu_code === 4
                );
                let lu_code_5 = dataInProvince.filter(
                  (d: any) => d.lu_code === 5
                );
                let lu_code_6 = dataInProvince.filter(
                  (d: any) => d.lu_code === 6
                );

                arrayOfLucode.lu_code_1 = _.sumBy(lu_code_1, "count_id");
                arrayOfLucode.lu_code_2 = _.sumBy(lu_code_2, "count_id");
                arrayOfLucode.lu_code_3 = _.sumBy(lu_code_3, "count_id");
                arrayOfLucode.lu_code_4 = _.sumBy(lu_code_4, "count_id");
                arrayOfLucode.lu_code_5 = _.sumBy(lu_code_5, "count_id");
                arrayOfLucode.lu_code_6 = _.sumBy(lu_code_6, "count_id");

                let total = _.sum([
                  arrayOfLucode?.lu_code_1 ? arrayOfLucode?.lu_code_1 : 0,
                  arrayOfLucode?.lu_code_2 ? arrayOfLucode?.lu_code_2 : 0,
                  arrayOfLucode?.lu_code_3 ? arrayOfLucode?.lu_code_3 : 0,
                  arrayOfLucode?.lu_code_4 ? arrayOfLucode?.lu_code_4 : 0,
                  arrayOfLucode?.lu_code_5 ? arrayOfLucode?.lu_code_5 : 0,
                  arrayOfLucode?.lu_code_6 ? arrayOfLucode?.lu_code_6 : 0,
                ]);

                arrayOfResult.push({
                  name: province.ProvinceName,
                  total: total,
                  lu_code_1: arrayOfLucode.lu_code_1,
                  lu_code_2: arrayOfLucode.lu_code_2,
                  lu_code_3: arrayOfLucode.lu_code_3,
                  lu_code_4: arrayOfLucode.lu_code_4,
                  lu_code_5: arrayOfLucode.lu_code_5,
                  lu_code_6: arrayOfLucode.lu_code_6,
                });
              } else {
                arrayOfResult.push({
                  name: province.ProvinceName,
                  total: 0,
                  lu_code_1: 0,
                  lu_code_2: 0,
                  lu_code_3: 0,
                  lu_code_4: 0,
                  lu_code_5: 0,
                  lu_code_6: 0,
                });
              }
            });
            barData = _.orderBy(arrayOfResult, "total", "desc");
            setBarChartData(barData);
            setBarChartAsean([]);
          } else if (params?.region && params?.region?.RegionCode !== "0") {
            const transformedData = _.chain(data.items)
              .groupBy("pv_idn")
              .map((items, pv_idn) => {
                const luCodeTotals: any = {
                  lu_code_1: 0,
                  lu_code_2: 0,
                  lu_code_3: 0,
                  lu_code_4: 0,
                  lu_code_5: 0,
                  lu_code_6: 0,
                };
                _.forEach(data.items, (item) => {
                  if (item.pv_idn === Number(pv_idn.toString())) {
                    luCodeTotals[`lu_code_${item.lu_code}`] += item.count_id;
                  }
                });
                const total: any = _.sumBy(items, "count_id");
                return {
                  name: items[0].pv_tn,
                  ...luCodeTotals,
                  total,
                };
              })
              .value();
            barData = _.orderBy(transformedData, "total", "desc");
          } else {
            let groupsData: any = {};
            let arrayOfResult: any = [];
            _.forEach(Regions, (region) => {
              let dataInRegions = data.items.filter(
                (item) => item.re_royin === region.RegionCode
              );
              groupsData[region.RegionCode] =
                dataInRegions.length > 0 ? dataInRegions : [];
            });

            _.forEach(Regions, (region) => {
              let dataInRegions = groupsData[region.RegionCode];
              if (dataInRegions.length > 0) {
                let arrayOfLucode: any = {};
                let lu_code_1 = dataInRegions.filter(
                  (d: any) => d.lu_code === 1
                );
                let lu_code_2 = dataInRegions.filter(
                  (d: any) => d.lu_code === 2
                );
                let lu_code_3 = dataInRegions.filter(
                  (d: any) => d.lu_code === 3
                );
                let lu_code_4 = dataInRegions.filter(
                  (d: any) => d.lu_code === 4
                );
                let lu_code_5 = dataInRegions.filter(
                  (d: any) => d.lu_code === 5
                );
                let lu_code_6 = dataInRegions.filter(
                  (d: any) => d.lu_code === 6
                );

                arrayOfLucode.lu_code_1 = _.sumBy(lu_code_1, "count_id");
                arrayOfLucode.lu_code_2 = _.sumBy(lu_code_2, "count_id");
                arrayOfLucode.lu_code_3 = _.sumBy(lu_code_3, "count_id");
                arrayOfLucode.lu_code_4 = _.sumBy(lu_code_4, "count_id");
                arrayOfLucode.lu_code_5 = _.sumBy(lu_code_5, "count_id");
                arrayOfLucode.lu_code_6 = _.sumBy(lu_code_6, "count_id");

                let total = _.sum([
                  arrayOfLucode?.lu_code_1 ? arrayOfLucode?.lu_code_1 : 0,
                  arrayOfLucode?.lu_code_2 ? arrayOfLucode?.lu_code_2 : 0,
                  arrayOfLucode?.lu_code_3 ? arrayOfLucode?.lu_code_3 : 0,
                  arrayOfLucode?.lu_code_4 ? arrayOfLucode?.lu_code_4 : 0,
                  arrayOfLucode?.lu_code_5 ? arrayOfLucode?.lu_code_5 : 0,
                  arrayOfLucode?.lu_code_6 ? arrayOfLucode?.lu_code_6 : 0,
                ]);

                arrayOfResult.push({
                  name: region.RegionName,
                  total: total,
                  lu_code_1: arrayOfLucode.lu_code_1,
                  lu_code_2: arrayOfLucode.lu_code_2,
                  lu_code_3: arrayOfLucode.lu_code_3,
                  lu_code_4: arrayOfLucode.lu_code_4,
                  lu_code_5: arrayOfLucode.lu_code_5,
                  lu_code_6: arrayOfLucode.lu_code_6,
                });
              } else {
                arrayOfResult.push({
                  name: region.RegionName,
                  total: 0,
                  lu_code_1: 0,
                  lu_code_2: 0,
                  lu_code_3: 0,
                  lu_code_4: 0,
                  lu_code_5: 0,
                  lu_code_6: 0,
                });
              }
            });

            barData = _.orderBy(arrayOfResult, "total", "desc");
          }
          setBarChartData(barData);
          setBarChartAsean([]);
        } else {
          const sortedItems = _.orderBy(data.items, ["count_id"], ["desc"]);
          const newArray: any = sortedItems.map((item, index) => ({
            id: index,
            name: item.ct_tn,
            value: item.count_id,
            color: colorArray[index],
          }));
          setBarChartAsean(_.orderBy(newArray, "value", "desc"));
          setBarChartData([]);
        }
      } else {
        setBarChartData([]);
        setBarChartAsean([]);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };
  const getDashboardStatus = async (params: FilterType | undefined) => {
    try {
      onSetLoading(true);
      let payload: DashBoardParamsType = {};
      let provinceList: any = [];
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();
        payload = {
          instrument: "VIIRS",
          ct_en: "Thailand",
          satellite: "Suomi NPP",
          groupby: "satellite,status",
          aggregate: "count:id,max:updated_at",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        if (params.countryType?.id === 1) {
          payload = {
            ct_en: "Thailand",
            groupby: "satellite,status",
            aggregate: "count:id,max:updated_at",
            limit: 10000,
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
            re_royin:
              params.region?.RegionName !== "ทั้งหมด"
                ? params.region?.RegionCode
                : undefined,
            ap_idn:
              params.district?.DistrictCode !== "0"
                ? params.district?.DistrictCode
                : undefined,
            tb_idn:
              params.subdistrict?.SubdistrictCode !== "0"
                ? params.subdistrict?.SubdistrictCode
                : undefined,
          };
          if (params.provinceGroup?.id === 2) {
            let northProvince = Provinces.filter(
              (e) => e.Group17Provinces === 1
            );
            provinceList = northProvince;
          } else {
            if (params.province) {
              if (params.province[0].ProvinceCode !== "0") {
                provinceList = params.province;
              }
            }
          }
        } else if (params.countryType?.id === 2) {
          payload = {
            asian: 1,
            groupby: "satellite,status",
            aggregate: "count:id,max:updated_at",
            limit: 10000,
            file_name: params.fileName,
          };
        }
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.satellite = params.satellite;
        }
      }
      const data = (await DashboardAPI(
        payload,
        provinceList.length > 0 ? provinceList : undefined
      )) as DashBoardResponseType;
      setHotspotStatusList(data?.items);
      const maxOfMaxTimestamps = _.maxBy(data.items, "max_updated_at");
      if (maxOfMaxTimestamps) {
        setDataDate(maxOfMaxTimestamps.max_updated_at);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };
  const getDashboardTable = async (params: FilterType | undefined) => {
    try {
      onSetLoading(true);
      let payload: DashBoardParamsType = {};
      let provinceList: any = [];
      if (params === undefined) {
        let startOfDay = new Date().setHours(0, 0, 0, 0);
        let endOfDay = new Date().setHours(23, 59, 59, 999);
        let startDate = moment(startOfDay).add(7, "hours").unix();
        let endDate = moment(endOfDay).add(7, "hours").unix();

        payload = {
          instrument: "VIIRS",
          satellite: "Suomi NPP",
          ct_en: "Thailand",
          groupby: "re_royin,lu_code,status",
          aggregate: "count:id,max:updated_at",
          limit: 10000,
          timestamp: `${startDate}/${endDate}`,
        };
      } else if (params) {
        if (params.countryType?.id === 1) {
          payload = {
            ct_en: "Thailand",
            groupby: "re_royin,lu_code,status",
            aggregate: "count:id,max:updated_at",
            limit: 10000,
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
          };

          if (params.provinceGroup?.id === 2) {
            let northProvince = Provinces.filter(
              (e) => e.Group17Provinces === 1
            );
            payload.groupby = "pv_idn,pv_tn,lu_code,status";
            provinceList = northProvince;
          }

          if (params.region?.RegionCode !== "0") {
            payload.re_royin = params.region?.RegionCode;
            payload.groupby = "pv_idn,pv_tn,lu_code,status";
          }

          if (params.province && params.province.length > 0) {
            const hasProvinceCodeZero = params.province.some(
              (item) => item.ProvinceCode === "0"
            );
            if (!hasProvinceCodeZero) {
              payload.groupby = "ap_idn,ap_tn,lu_code,status";
              provinceList = params.province;
            }
          }

          if (params.district?.DistrictCode !== "0") {
            payload.ap_idn = params.district?.DistrictCode;
            payload.groupby = "tb_idn,tb_tn,lu_code,status";
          }

          if (params.subdistrict?.SubdistrictCode !== "0") {
            payload.tb_idn = params.subdistrict?.SubdistrictCode;
            payload.groupby = "tb_idn,tb_tn,lu_code,status";
          }
        } else {
          payload = {
            asian: 1,
            groupby: "ct_en,ct_tn,instrument,lu_code,status,max:updated_at",
            aggregate: "count:id,max:updated_at",
            file_name:
              params.fileName?.trim() !== "" ? params.fileName : undefined,
            limit: 10000,
          };
        }
        if (params.startDate && params.endDate === null) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.startDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.startDate && params.endDate) {
          let startOfDate = new Date(params.startDate).setHours(0, 0, 0, 0);
          let endOfDate = new Date(params.endDate).setHours(23, 59, 59, 999);
          let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
          let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
          payload.timestamp = `${startOfDayTimestamp}/${endOfDayTimestamp}`;
        }
        if (params.satellite === "VIIRS" || params.satellite === "MODIS") {
          payload.instrument = params.satellite;
        }
        if (
          params.satellite === "Suomi NPP" ||
          params.satellite === "NOAA-20"
        ) {
          payload.satellite = params.satellite;
        }
      }
      const data = (await DashboardAPI(
        payload,
        provinceList.length > 0 ? provinceList : undefined
      )) as DashBoardResponseType;
      if (data.items.length > 0) {
        let maxDate: any = _.maxBy(data.items, "max_updated_at");
        setDataDate(maxDate?.max_updated_at);
        if (!params) {
          let groupedDataItems: any = {
            Central: data.items.filter((e) => e.re_royin === "Central"),
            West: data.items.filter((e) => e.re_royin === "West"),
            East: data.items.filter((e) => e.re_royin === "East"),
            Northeast: data.items.filter((e) => e.re_royin === "Northeast"),
            North: data.items.filter((e) => e.re_royin === "North"),
            South: data.items.filter((e) => e.re_royin === "South"),
          };
          let arrayOfResult: any = [];
          _.forEach(Regions, (region) => {
            let dataInRegions = groupedDataItems[region.RegionCode];
            if (dataInRegions.length > 0) {
              let arrayOfLucode: any = {};
              let lu_code_1 = dataInRegions.filter((d: any) => d.lu_code === 1);
              let lu_code_2 = dataInRegions.filter((d: any) => d.lu_code === 2);
              let lu_code_3 = dataInRegions.filter((d: any) => d.lu_code === 3);
              let lu_code_4 = dataInRegions.filter((d: any) => d.lu_code === 4);
              let lu_code_5 = dataInRegions.filter((d: any) => d.lu_code === 5);
              let lu_code_6 = dataInRegions.filter((d: any) => d.lu_code === 6);
              if (lu_code_1.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_1, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_1 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_1 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_2.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_2, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_2 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_2 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_3.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_3, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_3 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_3 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_4.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_4, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_4 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_4 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_5.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_5, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_5 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_5 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }
              if (lu_code_6.length > 0) {
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
                _.forEach(lu_code_6, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                arrayOfLucode.lu_code_6 = {
                  pending: statusCounts.pending,
                  inprogress: statusCounts.inprogress,
                  complete: statusCounts.complete,
                  total: statusCounts.total,
                };
              } else {
                arrayOfLucode.lu_code_6 = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };
              }

              let total = _.sum([
                arrayOfLucode?.lu_code_1 ? arrayOfLucode?.lu_code_1?.total : 0,
                arrayOfLucode?.lu_code_2 ? arrayOfLucode?.lu_code_2?.total : 0,
                arrayOfLucode?.lu_code_3 ? arrayOfLucode?.lu_code_3?.total : 0,
                arrayOfLucode?.lu_code_4 ? arrayOfLucode?.lu_code_4?.total : 0,
                arrayOfLucode?.lu_code_5 ? arrayOfLucode?.lu_code_5?.total : 0,
                arrayOfLucode?.lu_code_6 ? arrayOfLucode?.lu_code_6?.total : 0,
              ]);
              arrayOfResult.push({
                name: region.RegionName,
                total: total,
                lu_code_1: arrayOfLucode?.lu_code_1,
                lu_code_2: arrayOfLucode?.lu_code_2,
                lu_code_3: arrayOfLucode?.lu_code_3,
                lu_code_4: arrayOfLucode?.lu_code_4,
                lu_code_5: arrayOfLucode?.lu_code_5,
                lu_code_6: arrayOfLucode?.lu_code_6,
              });
            } else {
              arrayOfResult.push({
                name: region.RegionName,
                total: 0,
                lu_code_1: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_2: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_3: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_4: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_5: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
                lu_code_6: {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                },
              });
            }
          });
          setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
          setTableColumnName("ภูมิภาค");
          setTotalItems(arrayOfResult.length);
          setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
        } else {
          if (params.countryType?.value === "ประเทศไทย") {
            if (
              (params?.district && params?.district?.DistrictCode !== "0") ||
              (params?.subdistrict &&
                params?.subdistrict?.SubdistrictCode !== "0")
            ) {
              let id = 0;
              let total = 0;
              const result: any = [];
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.tb_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [tb_idn, lu_code] = groupKey.split("_");
                if (!counts[tb_idn]) {
                  counts[tb_idn] = {};
                }
                const luCodeObject = counts[tb_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, tb_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);

                const subdistrictInfo = _.find(SubDistrict, {
                  SubdistrictCode: tb_idn.toString(),
                });

                const districtInfo = _.find(Districts, {
                  DistrictCode: subdistrictInfo?.DistrictCode,
                });

                const provinceInfo = _.find(Provinces, {
                  ProvinceCode: districtInfo?.ProvinceCode,
                });

                const resultObject = {
                  id: id + 1,
                  name: subdistrictInfo ? subdistrictInfo.SubdistrictName : "",
                  districtName: districtInfo ? districtInfo.DistrictName : "",
                  provinceName: provinceInfo ? provinceInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });

              let sortedData = result.sort((a: any, b: any) => {
                const provinceComparison = a.provinceName.localeCompare(
                  b.provinceName
                );
                const districtComparison =
                  provinceComparison === 0
                    ? a.districtName.localeCompare(b.districtName)
                    : provinceComparison;
                return districtComparison === 0
                  ? a.name.localeCompare(b.name)
                  : districtComparison;
              });
              setDataTable(sortedData);
              setTableColumnName("ตำบล");
              setTotalItems(sortedData.length);
              setOldDataTable(sortedData);
            } else if (
              params?.province &&
              params?.province[0].ProvinceCode !== "0"
            ) {
              let id = 0;
              let total = 0;
              const result: any = [];
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.ap_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [ap_idn, lu_code] = groupKey.split("_");
                if (!counts[ap_idn]) {
                  counts[ap_idn] = {};
                }
                const luCodeObject = counts[ap_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, ap_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);
                const districtInfo = _.find(Districts, {
                  DistrictCode: ap_idn.toString(),
                });

                const provinceInfo = _.find(Provinces, {
                  ProvinceCode: districtInfo?.ProvinceCode,
                });
                const resultObject = {
                  id: id + 1,
                  name: districtInfo ? districtInfo.DistrictName : "",
                  provinceName: provinceInfo ? provinceInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });

              let sortedData = result.sort((a: any, b: any) => {
                const provinceComparison = a.provinceName.localeCompare(
                  b.provinceName
                );
                return provinceComparison === 0
                  ? a.name.localeCompare(b.name)
                  : provinceComparison;
              });
              setDataTable(sortedData);
              setTableColumnName("อำเภอ");
              setTotalItems(sortedData.length);
              setOldDataTable(sortedData);
            } else if (params.provinceGroup?.id === 2) {
              let arrayOfResult: any = [];
              let groupData: any = {};
              let groupProvinces = Provinces.filter(
                (p) => p.Group17Provinces === 1
              );
              _.forEach(groupProvinces, (province) => {
                let dataInProvince = data.items.filter(
                  (item) => item.pv_idn === Number(province.ProvinceCode)
                );
                groupData[`${province.ProvinceCode}`] = dataInProvince;
              });

              _.forEach(groupProvinces, (province) => {
                let dataInProvince = groupData[province.ProvinceCode];
                if (dataInProvince.length > 0) {
                  let arrayOfLucode: any = {};
                  let lu_code_1 = dataInProvince.filter(
                    (d: any) => d.lu_code === 1
                  );
                  let lu_code_2 = dataInProvince.filter(
                    (d: any) => d.lu_code === 2
                  );
                  let lu_code_3 = dataInProvince.filter(
                    (d: any) => d.lu_code === 3
                  );
                  let lu_code_4 = dataInProvince.filter(
                    (d: any) => d.lu_code === 4
                  );
                  let lu_code_5 = dataInProvince.filter(
                    (d: any) => d.lu_code === 5
                  );
                  let lu_code_6 = dataInProvince.filter(
                    (d: any) => d.lu_code === 6
                  );

                  if (lu_code_1.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_1, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_1 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_1 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_2.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_2, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_2 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_2 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_3.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_3, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_3 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_3 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_4.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_4, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_4 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_4 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_5.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_5, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_5 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_5 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_6.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_6, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_6 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_6 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }

                  let total = _.sum([
                    arrayOfLucode?.lu_code_1
                      ? arrayOfLucode?.lu_code_1?.total
                      : 0,
                    arrayOfLucode?.lu_code_2
                      ? arrayOfLucode?.lu_code_2?.total
                      : 0,
                    arrayOfLucode?.lu_code_3
                      ? arrayOfLucode?.lu_code_3?.total
                      : 0,
                    arrayOfLucode?.lu_code_4
                      ? arrayOfLucode?.lu_code_4?.total
                      : 0,
                    arrayOfLucode?.lu_code_5
                      ? arrayOfLucode?.lu_code_5?.total
                      : 0,
                    arrayOfLucode?.lu_code_6
                      ? arrayOfLucode?.lu_code_6?.total
                      : 0,
                  ]);
                  arrayOfResult.push({
                    name: province.ProvinceName,
                    total: total,
                    lu_code_1: arrayOfLucode?.lu_code_1,
                    lu_code_2: arrayOfLucode?.lu_code_2,
                    lu_code_3: arrayOfLucode?.lu_code_3,
                    lu_code_4: arrayOfLucode?.lu_code_4,
                    lu_code_5: arrayOfLucode?.lu_code_5,
                    lu_code_6: arrayOfLucode?.lu_code_6,
                  });
                } else {
                  arrayOfResult.push({
                    name: province.ProvinceName,
                    total: 0,
                    lu_code_1: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_2: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_3: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_4: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_5: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_6: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                  });
                }
              });

              setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setTableColumnName("จังหวัด");
              setTotalItems(arrayOfResult.length);
            } else if (params?.region && params?.region?.RegionCode !== "0") {
              let id = 0;
              const result: any = [];
              let total = 0;
              const groupedData = _.groupBy(
                data.items,
                (item) => `${item.pv_idn}_${item.lu_code}`
              );
              const counts: any = {};
              _.forEach(groupedData, (groupedItems, groupKey) => {
                const [pv_idn, lu_code] = groupKey.split("_");
                if (!counts[pv_idn]) {
                  counts[pv_idn] = {};
                }
                const luCodeObject = counts[pv_idn];
                const statusCounts: any = {
                  pending: 0,
                  inprogress: 0,
                  complete: 0,
                  total: 0,
                };

                _.forEach(groupedItems, (item) => {
                  statusCounts["total"] += item.count_id;
                  if (item.status === "pending") {
                    statusCounts["pending"] += item.count_id;
                  } else if (item.status === "in-progress") {
                    statusCounts["inprogress"] += item.count_id;
                  } else if (item.status === "completed") {
                    statusCounts["complete"] += item.count_id;
                  }
                });
                luCodeObject[`lu_code_${lu_code}`] = statusCounts;
              });
              _.forEach(counts, (luCodes, pv_idn) => {
                total = 0;
                total = _.sum([
                  luCodes?.lu_code_1 ? luCodes?.lu_code_1?.total : 0,
                  luCodes?.lu_code_2 ? luCodes?.lu_code_2?.total : 0,
                  luCodes?.lu_code_3 ? luCodes?.lu_code_3?.total : 0,
                  luCodes?.lu_code_4 ? luCodes?.lu_code_4?.total : 0,
                  luCodes?.lu_code_5 ? luCodes?.lu_code_5?.total : 0,
                  luCodes?.lu_code_6 ? luCodes?.lu_code_6?.total : 0,
                ]);
                const provincesInfo = _.find(Provinces, {
                  ProvinceCode: pv_idn.toString(),
                });
                const resultObject = {
                  id: id + 1,
                  name: provincesInfo ? provincesInfo.ProvinceName : "",
                  ...luCodes,
                  total: total,
                };
                result.push(resultObject);
                id = id + 1;
              });

              setDataTable(orderBy(result, ["name"], ["asc"]));
              setOldDataTable(orderBy(result, ["name"], ["asc"]));
              setTableColumnName("จังหวัด");
              setTotalItems(result.length);
            } else {
              let groupedDataItems: any = {
                Central: data.items.filter((e) => e.re_royin === "Central"),
                West: data.items.filter((e) => e.re_royin === "West"),
                East: data.items.filter((e) => e.re_royin === "East"),
                Northeast: data.items.filter((e) => e.re_royin === "Northeast"),
                North: data.items.filter((e) => e.re_royin === "North"),
                South: data.items.filter((e) => e.re_royin === "South"),
              };
              let arrayOfResult: any = [];
              _.forEach(Regions, (region) => {
                let dataInRegions = groupedDataItems[region.RegionCode];
                if (dataInRegions.length > 0) {
                  let arrayOfLucode: any = {};
                  let lu_code_1 = dataInRegions.filter(
                    (d: any) => d.lu_code === 1
                  );
                  let lu_code_2 = dataInRegions.filter(
                    (d: any) => d.lu_code === 2
                  );
                  let lu_code_3 = dataInRegions.filter(
                    (d: any) => d.lu_code === 3
                  );
                  let lu_code_4 = dataInRegions.filter(
                    (d: any) => d.lu_code === 4
                  );
                  let lu_code_5 = dataInRegions.filter(
                    (d: any) => d.lu_code === 5
                  );
                  let lu_code_6 = dataInRegions.filter(
                    (d: any) => d.lu_code === 6
                  );
                  if (lu_code_1.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_1, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_1 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_1 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_2.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_2, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_2 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_2 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_3.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_3, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_3 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_3 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_4.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_4, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_4 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_4 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_5.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_5, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_5 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_5 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }
                  if (lu_code_6.length > 0) {
                    const statusCounts: any = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                    _.forEach(lu_code_6, (item) => {
                      statusCounts["total"] += item.count_id;
                      if (item.status === "pending") {
                        statusCounts["pending"] += item.count_id;
                      } else if (item.status === "in-progress") {
                        statusCounts["inprogress"] += item.count_id;
                      } else if (item.status === "completed") {
                        statusCounts["complete"] += item.count_id;
                      }
                    });
                    arrayOfLucode.lu_code_6 = {
                      pending: statusCounts.pending,
                      inprogress: statusCounts.inprogress,
                      complete: statusCounts.complete,
                      total: statusCounts.total,
                    };
                  } else {
                    arrayOfLucode.lu_code_6 = {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    };
                  }

                  let total = _.sum([
                    arrayOfLucode?.lu_code_1
                      ? arrayOfLucode?.lu_code_1?.total
                      : 0,
                    arrayOfLucode?.lu_code_2
                      ? arrayOfLucode?.lu_code_2?.total
                      : 0,
                    arrayOfLucode?.lu_code_3
                      ? arrayOfLucode?.lu_code_3?.total
                      : 0,
                    arrayOfLucode?.lu_code_4
                      ? arrayOfLucode?.lu_code_4?.total
                      : 0,
                    arrayOfLucode?.lu_code_5
                      ? arrayOfLucode?.lu_code_5?.total
                      : 0,
                    arrayOfLucode?.lu_code_6
                      ? arrayOfLucode?.lu_code_6?.total
                      : 0,
                  ]);
                  arrayOfResult.push({
                    name: region.RegionName,
                    total: total,
                    lu_code_1: arrayOfLucode?.lu_code_1,
                    lu_code_2: arrayOfLucode?.lu_code_2,
                    lu_code_3: arrayOfLucode?.lu_code_3,
                    lu_code_4: arrayOfLucode?.lu_code_4,
                    lu_code_5: arrayOfLucode?.lu_code_5,
                    lu_code_6: arrayOfLucode?.lu_code_6,
                  });
                } else {
                  arrayOfResult.push({
                    name: region.RegionName,
                    total: 0,
                    lu_code_1: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_2: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_3: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_4: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_5: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                    lu_code_6: {
                      pending: 0,
                      inprogress: 0,
                      complete: 0,
                      total: 0,
                    },
                  });
                }
              });
              setDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
              setTableColumnName("ภูมิภาค");
              setTotalItems(arrayOfResult.length);
              setOldDataTable(orderBy(arrayOfResult, ["name"], ["asc"]));
            }
          } else {
            let id = 0;
            const groupedData = _.groupBy(data.items, "ct_tn");
            const result: any = _.map(groupedData, (group, ct_tn) => {
              const VIIRSCount = _.sumBy(group, (item) =>
                item.instrument === "VIIRS" ? item.count_id : 0
              );
              const MODISCount = _.sumBy(group, (item) =>
                item.instrument === "MODIS" ? item.count_id : 0
              );
              const total = VIIRSCount + MODISCount;
              const maxTimestamp = _.maxBy(
                group,
                "max_updated_at"
              )?.max_updated_at;
              id = id + 1;
              return {
                id: id + 1,
                name: ct_tn,
                VIIRS: VIIRSCount,
                MODIS: MODISCount,
                total: total,
                max_timestamp: maxTimestamp,
              };
            });
            setDataTable(orderBy(result, ["name"], ["asc"]));
            setTableColumnName("ประเทศ");
            setTotalItems(result.length);
            setOldDataTable(orderBy(result, ["name"], ["asc"]));
          }
        }
      } else {
        setDataTable([]);
        setOldDataTable([]);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };
  const handleCalculatePagination = (data: any, itemsPerPage: number) => {
    const totalPages = Math.ceil(data.length / itemsPerPage);
    setTotalPage(totalPages);
    setItemStart(0);
    setCurrentPage(1);
    setDataTable(oldDataTable.slice(0, itemsPerPage));
  };
  const handleSelectPage = (page: number) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * limit;
    setItemStart(startIndex);
    const endIndex = startIndex + limit;
    setDataTable(oldDataTable.slice(startIndex, endIndex));
  };

  const handleSortDataBarChart = () => {
    if (barChartData && barChartData?.length > 0) {
      let sortedData: any = [];
      if (sorted === "DESC") {
        sortedData = _.sortBy(barChartData, "total");
      } else if (sorted === "ASC") {
        sortedData = _.reverse(_.sortBy(barChartData, "total"));
      }
      setSorted((s) => (s === "ASC" ? "DESC" : "ASC"));
      setBarChartData(sortedData);
    }
    if (barChartAsean && barChartAsean.length > 0) {
      let sortedData: any = [];
      if (sorted === "DESC") {
        sortedData = _.sortBy(barChartAsean, "value");
      } else if (sorted === "ASC") {
        sortedData = _.reverse(_.sortBy(barChartAsean, "value"));
      }
      setSorted((s) => (s === "ASC" ? "DESC" : "ASC"));
      setBarChartAsean(sortedData);
    }
  };

  const handleSortDataTable = () => {
    if (sortedTable === "DESC") {
      let sortedDataAsc = _.sortBy(dataTable, "total");
      setDataTable(sortedDataAsc);
      setSortedTable("ASC");
    } else if (sortedTable === "ASC") {
      let sortedDataDesc = _.reverse(_.sortBy(dataTable, "total"));
      setDataTable(sortedDataDesc);
      setSortedTable("DESC");
    }
  };
  const handleFormatTextTitleBarChart = (filter?: FilterType) => {
    if (!filter) {
      let title = "ระดับภูมิภาค";
      setBarChartTitle(title);
    }
    if (filter) {
      if (filter.countryType?.id === 1) {
        let title = "ระดับภูมิภาค";
        if (filter.provinceGroup?.id === 2) {
          title = "ระดับจังหวัด";
        }
        if (filter.region?.RegionCode !== "0") {
          title = "ระดับจังหวัด";
        }
        if (filter.province) {
          const hasProvinceCodeZero = filter.province.some(
            (item) => item.ProvinceCode === "0"
          );
          if (!hasProvinceCodeZero) {
            title = "ระดับอำเภอ";
          }
        }
        if (
          filter.subdistrict?.SubdistrictCode !== "0" ||
          filter.district?.DistrictCode !== "0"
        ) {
          title = "ระดับตำบล";
        }

        setBarChartTitle(title);
      } else if (filter.countryType?.id === 2) {
        let title = "ระดับประเทศ";
        setBarChartTitle(title);
      }
    }
  };
  const handleFormatTextTitlDataTable = (filter?: FilterType) => {
    if (!filter) {
      let title = "ระดับภูมิภาค";
      setDataTableTitle(title);
    }
    if (filter) {
      if (filter.countryType?.id === 1) {
        let title = "ระดับภูมิภาค";
        if (filter.provinceGroup?.id === 2) {
          title = "ระดับจังหวัด";
        }

        if (filter.region?.RegionCode !== "0") {
          title = "ระดับจังหวัด";
        }
        if (filter.province) {
          const hasProvinceCodeZero = filter.province.some(
            (item) => item.ProvinceCode === "0"
          );
          if (!hasProvinceCodeZero) {
            title = "ระดับอำเภอ";
          }
        }
        if (
          filter.subdistrict?.SubdistrictCode !== "0" ||
          filter.district?.DistrictCode !== "0"
        ) {
          title = "ระดับตำบล";
        }

        setDataTableTitle(title);
      } else if (filter.countryType?.id === 2) {
        let title = "ระดับประเทศ";
        setDataTableTitle(title);
      }
    }
  };
  const handleCheckPlatform = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf("Chrome") !== -1) {
      setBrowserInfo({
        name: "Chrome",
      });
    } else if (userAgent.indexOf("Firefox") !== -1) {
      setBrowserInfo({
        name: "Firefox",
      });
    } else if (userAgent.indexOf("Safari") !== -1) {
      setBrowserInfo({
        name: "Safari",
      });
    } else if (userAgent.indexOf("Edg") !== -1) {
      setBrowserInfo({
        name: "Edg",
      });
    }
  };
  useEffect(() => {
    getDashboardDonutData(filterData);
    getDashboardBarData(filterData);
    getDashboardStatus(filterData);
    getDashboardTable(filterData);
    handleFormatTextTitlDataTable(filterData);
  }, [filterData]);

  useEffect(() => {
    handleCalculatePagination(oldDataTable, limit);
  }, [oldDataTable, limit]);

  useEffect(() => {
    if (donutType === "Thailand") {
      setBarChartCountItem(barChartData ? barChartData?.length : 0);
    }
    if (donutType === "Asean") {
      setBarChartCountItem(barChartAsean ? barChartAsean.length : 0);
    }
    handleFormatTextTitleBarChart(filterData);
  }, [barChartAsean, barChartData, filterData]);

  useEffect(() => {
    handleCheckPlatform();
  }, []);

  return (
    <div className="mt-7 flex flex-col gap-2">
      <div id="dashboard" className="flex flex-col gap-2 w-full h-fit">
        <div className="flex justify-end">
          <FilterComponent
            positionClass="right-0 top-0"
            filters={filterData}
            onFilterChanged={handleFilter}
          />
        </div>
        <HotspotInfo data={hotspotStatusList} filterData={filterData} />
        <div className="grid grid-cols-6 gap-2">
          <div className="w-full h-full min-h-[700px] max-h-full col-span-2">
            <Maps filter={filterData} />
          </div>
          <div className="col-span-4 flex flex-col gap-2 w-full">
            <div className="w-full h-full bg-primary-contrast shadow-z8 rounded-[32px] px-6 pt-6 pb-4 flex justify-between">
              <div className="flex flex-col gap-4 w-full">
                <p className="text-text-primary text-sm font-normal">
                  เขตพื้นที่รับผิดชอบ
                  <span className="font-light">{`${
                    filterData === undefined ||
                    filterData.countryType?.value === "ประเทศไทย"
                      ? " (ประเทศไทย)"
                      : " (อาเซียน)"
                  }`}</span>
                </p>
                {donutChartData?.length > 0 ? (
                  <HotspotInfoDonutChart
                    hotspotData={donutChartData}
                    dataType={donutType}
                  />
                ) : (
                  <NotFoundData />
                )}
              </div>
            </div>
            <div className="w-full h-full bg-primary-contrast shadow-z8 rounded-[32px] p-6 flex flex-col gap-1">
              <div className="flex justify-between">
                <p className="text-text-primary text-sm font-normal">
                  จำนวนจุดความร้อนใน
                  {filterData === undefined ||
                  filterData?.countryType?.value === "ประเทศไทย"
                    ? "ประเทศไทย"
                    : "อาเซียน"}
                </p>
                <button
                  onClick={() => handleSortDataBarChart()}
                  disabled={!barChartAsean && !barChartData}
                  className="flex gap-2 rounded-lg px-2 py-1 shadow-z1  bg-gray-1 h-8 items-center"
                >
                  <p className="text-[10px] text-text-primary">เรียงตาม</p>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.33398 10.6666L5.33398 12.6666M5.33398 12.6666L3.33398 10.6666M5.33398 12.6666V3.33325M8.66732 5.33325L10.6673 3.33325M10.6673 3.33325L12.6673 5.33325M10.6673 3.33325V12.6666"
                      stroke="#5D5D5D"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <p className="text-xs text-text-primary font-normal">
                {barChartTitle}
                <span className="text-text-secondary">{` (ทั้งหมด: ${barChartCountItem}) `}</span>
                {((barChartData && barChartData?.length > 0) ||
                  (barChartAsean && barChartAsean?.length > 0)) &&
                dataDate ? (
                  <span className="text-gray-4 font-light">
                    {` ปรับปรุงข้อมูลล่าสุดเมื่อ: ${moment(new Date(dataDate))
                      .add(543, "years")
                      .format("DD/MM/YYYY")}`}
                  </span>
                ) : (
                  ""
                )}
              </p>
              {donutType === "Thailand" ? (
                <>
                  {barChartData && barChartData.length > 0 ? (
                    <HotSpotInfoBarchart
                      dataType={donutType}
                      hotspot={barChartData}
                      hotspotAsean={barChartAsean}
                    />
                  ) : (
                    <NotFoundData />
                  )}
                </>
              ) : (
                <>
                  {barChartAsean && barChartAsean.length > 0 ? (
                    <HotSpotInfoBarchart
                      dataType={donutType}
                      hotspot={barChartData}
                      hotspotAsean={barChartAsean}
                    />
                  ) : (
                    <NotFoundData />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 w-auto mb-8">
        <div className="w-full h-full bg-primary-contrast flex flex-col gap-6 p-6 rounded-[32px] ">
          {dataTable?.length > 0 ? (
            <>
              <div className="w-full flex flex-col gap-2">
                <div className="flex justify-between items-center">
                  <p className="text-text-primary text-sm font-normal">
                    ตารางแสดงรายละเอียด{dataTableTitle}
                    <span className="text-text-secondary">{` (ทั้งหมด: ${totalItems})`}</span>
                  </p>
                  <button
                    onClick={() => handleSortDataTable()}
                    disabled={dataTable.length < 0}
                    className="flex gap-2 rounded-lg px-2 py-1 shadow-z1 bg-gray-1 h-8 items-center"
                  >
                    <p className="text-[10px] text-text-primary">เรียงตาม</p>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.33398 10.6666L5.33398 12.6666M5.33398 12.6666L3.33398 10.6666M5.33398 12.6666V3.33325M8.66732 5.33325L10.6673 3.33325M10.6673 3.33325L12.6673 5.33325M10.6673 3.33325V12.6666"
                        stroke="#5D5D5D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div className="overflow-x-scroll">
                  <HotSpotInfoTable
                    columnName={tableColumnName}
                    hotspot={dataTable}
                    dataType={donutType}
                    startItem={itemStart}
                  />
                </div>
              </div>
              <PagePaginate
                onSelectPage={handleSelectPage}
                onSelectLimit={setLimit}
                currentPage={currentPage}
                totalPage={totalPage}
                itemStart={itemStart}
                limit={limit}
                totalItems={totalItems}
              />
            </>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <p className="text-text-primary text-sm font-normal">
                  ตารางแสดงรายละเอียด{dataTableTitle}
                  <span className="text-text-secondary">{` (ทั้งหมด: ${oldDataTable?.length})`}</span>
                </p>
                <button className="flex gap-2 rounded-lg px-2 py-1 shadow-z1 bg-gray-1 h-6">
                  <p className="text-[10px] text-text-primary">เรียงตาม</p>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.33398 10.6666L5.33398 12.6666M5.33398 12.6666L3.33398 10.6666M5.33398 12.6666V3.33325M8.66732 5.33325L10.6673 3.33325M10.6673 3.33325L12.6673 5.33325M10.6673 3.33325V12.6666"
                      stroke="#5D5D5D"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <NotFoundData />
            </>
          )}
        </div>

        <button
          onClick={() => handlePrintPage()}
          className="h-10 self-end w-[137px] px-4 py-2 flex gap-2 border-[1px] bg-primary-main border-gray-2 rounded-xl p-2 items-center "
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 16.983C3.447 16.936 2.52 16.763 1.879 16.121C1 15.243 1 13.828 1 11C1 8.172 1 6.757 1.879 5.879C2.757 5 4.172 5 7 5H15C17.828 5 19.243 5 20.121 5.879C21 6.757 21 8.172 21 11C21 13.828 21 15.243 20.121 16.121C19.48 16.763 18.554 16.936 17 16.983"
              stroke="white"
              strokeWidth="1.5"
            />
            <path
              d="M8 9H5M18 13H4"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M17.75 13C17.75 12.8011 17.671 12.6103 17.5303 12.4697C17.3897 12.329 17.1989 12.25 17 12.25C16.8011 12.25 16.6103 12.329 16.4697 12.4697C16.329 12.6103 16.25 12.8011 16.25 13H17.75ZM5.75 13C5.75 12.8011 5.67098 12.6103 5.53033 12.4697C5.38968 12.329 5.19891 12.25 5 12.25C4.80109 12.25 4.61032 12.329 4.46967 12.4697C4.32902 12.6103 4.25 12.8011 4.25 13H5.75ZM16.25 15C16.25 16.435 16.248 17.436 16.147 18.192C16.048 18.926 15.867 19.314 15.591 19.591L16.651 20.651C17.254 20.05 17.512 19.291 17.634 18.391C17.752 17.513 17.75 16.393 17.75 15H16.25ZM11 21.75C12.393 21.75 13.513 21.752 14.392 21.634C15.292 21.512 16.05 21.254 16.652 20.652L15.59 19.59C15.313 19.867 14.925 20.047 14.19 20.146C13.435 20.247 12.434 20.249 10.999 20.249V21.749L11 21.75ZM11 1.75C12.435 1.75 13.437 1.752 14.192 1.853C14.926 1.952 15.314 2.133 15.591 2.409L16.651 1.349C16.05 0.746002 15.291 0.488002 14.391 0.367002C13.513 0.248002 12.393 0.250002 11 0.250002V1.75ZM11 0.250002C9.607 0.250002 8.487 0.248002 7.608 0.367002C6.708 0.487002 5.95 0.747002 5.348 1.348L6.41 2.41C6.687 2.133 7.075 1.953 7.81 1.854C8.564 1.753 9.566 1.751 11.001 1.751V0.251002L11 0.250002ZM4.25 15C4.25 16.393 4.248 17.513 4.367 18.392C4.487 19.292 4.747 20.05 5.348 20.652L6.41 19.59C6.133 19.313 5.953 18.925 5.854 18.19C5.753 17.435 5.751 16.434 5.751 14.999H4.251L4.25 15ZM11 20.25C9.565 20.25 8.563 20.248 7.808 20.147C7.074 20.048 6.686 19.867 6.409 19.591L5.349 20.651C5.95 21.254 6.709 21.512 7.609 21.634C8.487 21.752 9.607 21.75 11 21.75V20.25ZM17.732 4.977C17.686 3.435 17.524 2.22 16.652 1.348L15.59 2.41C16 2.82 16.185 3.459 16.232 5.024L17.732 4.977ZM5.767 5.023C5.814 3.458 5.998 2.82 6.409 2.409L5.349 1.349C4.476 2.22 4.314 3.435 4.268 4.977L5.767 5.023ZM17.75 15V13H16.25V15H17.75ZM5.75 15V13H4.25V15H5.75Z"
              fill="white"
            />
            <path
              d="M16 10C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10Z"
              fill="white"
            />
            <path
              d="M14 15.5H8M12 18H8"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>

          <p className="text-sm text-primary-contrast">พรินต์ทั้งหน้า</p>
        </button>
      </div>
    </div>
  );
}

export default DashBoard;
